import { Routes, Route } from 'react-router-dom';
import { MissionsList } from '@/_features/missions/components/missions-list/missions-list';
import { MissionDashboard } from '@/_features/missions/components/mission-dashboard/mission-dashboard';

function Missions() {
  return (
    <Routes>
      <Route path="/" element={<MissionsList />} />
      <Route path="/:missionId" element={<MissionDashboard />} />
    </Routes>
  );
}

export default Missions;
